<template>
  <section class="arview-popup">
    <div
      class="arview-wrapper"
      @mouseenter="showCloseButton = true"
      @mouseleave="showCloseButton = false"
    >
      <iframe
        class="arview-iframe"
        allow="fullscreen"
        :style="arViewEmbedSize"
        :src="arViewUrl"
      />
      <button
        v-if="closeButtonVisible"
        class="close-marker-button"
        @click="closeMarkerInfo"
      >
        <i class="isif isif-times" />
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isMobile } from '@/api/utils'
import { isArViewerUrl, ARVIEWER_QUERIES } from '@/api/armaker'

export default {
  name: 'PopupArView',
  props: {
    isTourRingClient: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      windowInnerWidth: window.innerWidth,
      windowInnerHeight: window.innerHeight,
      showCloseButton: false
    }
  },
  computed: {
    ...mapGetters('arview', [
      'arViewPopupAction',
      'arViewPopupSize'
    ]),
    closeButtonVisible () {
      return (this.showCloseButton || isMobile()) && !this.isTourRingClient
    },
    arViewQuery () {
      return `${ARVIEWER_QUERIES.vrmakerOnly}&${ARVIEWER_QUERIES.noBackground}`
    },
    arViewUrl () {
      let url = this.arViewPopupAction.url || ''
      if (url) {
        url += (url.includes('?') ? '&' : '?') + this.arViewQuery
      }
      return url
    },
    arViewEmbedSize () {
      const width = this.windowInnerWidth * this.arViewPopupSize.widthPercent / 100
      let height = 0
      // embed size should be 16:9 or 9:16
      if (this.windowInnerWidth > this.windowInnerHeight) {
        height = width * 9 / 16
      } else {
        height = width * 16 / 9
      }
      return {
        width: `${width}px`,
        height: `${height}px`
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.windowWidthHandler)
    window.addEventListener('keydown', this.onEscape)
    window.addEventListener('message', this.arEventHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowWidthHandler)
    window.removeEventListener('keydown', this.onEscape)
    window.removeEventListener('message', this.arEventHandler)
  },
  methods: {
    ...mapActions('arview', [
      'closeArViewPopup'
    ]),
    windowWidthHandler () {
      this.windowInnerWidth = window.innerWidth
      this.windowInnerHeight = window.innerHeight
    },
    arEventHandler (e) {
      if (!isArViewerUrl(e.origin)) return
      if (e.data && e.data.action === 'close') {
        this.closeArViewPopup()
      }
    },
    onEscape (e) {
      if (e.keyCode === 27) {
        this.closeMarkerInfo()
      }
    },
    closeMarkerInfo () {
      this.$emit('closeMarkerInfo')
    }
  }
}
</script>

<style lang="stylus" scoped>
.arview-popup {
  width: 100%
  height: 100%
  position: absolute
  z-index: 200
  top: 0
  right: 0
  bottom: 0
  left: 0
  margin: auto
  background-color: rgba(#333, .5)
  display: flex
  justify-content: center

  .arview-wrapper {
    height: 100%
    display: flex
    align-items: center
    position: relative

    .close-marker-button {
      width: 60px
      height: 60px
      border-radius: 50%
      background-color: rgba(#333, .8)
      font-size: 20px
      color: #fff
      display: flex
      justify-content: center
      align-items: center
      cursor: pointer
      position: absolute
      top: 20px
      left: 0
      right: 0
      margin: auto
    }
    .arview-iframe {
      max-width: 100%
      min-width: 320px
    }
  }
}
</style>
